import Request from "../Request.js";
import store from "@/store"

const projects = {
  getProject(id) {
    const bobbieToken = store.state.auth?.bobbieToken;
    return Request.get(`/project/api/v1/projects/${id}/`, {}, {
      headers: bobbieToken ? {'X-Bobbie-Token': bobbieToken} : {}
    });
  },
  getFastFusionModel(id) {
    return Request.get(`/project/api/v1/projects/${id}/cameras-csv/`);
  },
  patchProject(id, data) {
    return Request.patch(`/project/api/v1/projects/${id}/`, data);
  },
  shareFastFusionSolarModel(data) {
    return Request.post(
      `/authentication/api/v1/share-fast-fusion-solar/`,
      data
    );
  },
  // Same token, mailed to the recipients instead of returned to the caller.
  shareFastFusionSolarModelByEmail(data) {
    return Request.post(
      `/authentication/api/v1/share-fast-fusion-solar/email/`,
      data
    );
  },
};

export default projects;
